var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-video"},on:{"mouseover":function($event){_vm.hoveredVideo=true},"mouseleave":function($event){_vm.hoveredVideo=false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }